/* unplugin-vue-components disabled */import { render } from "./profile.vue?vue&type=template&id=4aa3d25b&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=4aa3d25b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa3d25b"],['__file',"src/pages/settings/profile/profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aa3d25b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aa3d25b', __exports__)) {
    api.reload('4aa3d25b', __exports__)
  }
  
  module.hot.accept("./profile.vue?vue&type=template&id=4aa3d25b&scoped=true", () => {
    api.rerender('4aa3d25b', render)
  })

}


export default __exports__